import { totalItems } from './commonActions';
import {
  RemoveUnitRoleRequestInterface,
  UnitEntityInterface,
  UnitQueryInterface,
  UpdateUnitRoleRequestInterface,
} from '@types';
import { setNotification } from '@actions/appActions';
import { unitActionTypes } from '@actions/actionTypes/unit';
import { assignUnitRole, getAllUnits, removeUnitRole } from '@services/unitService';

export const setUnits = (units: UnitEntityInterface[]) => {
  return {
    type: unitActionTypes.SET_UNITS,
    payload: units,
  };
};

export const makeAddUnitRole = (unitId: string, data: UpdateUnitRoleRequestInterface) => {
  return async (dispatch, getState) => {
    try {
      await assignUnitRole(unitId, data);
      const store = getState();
      const filters = store.unit.unitsFilters;

      const updatedQuery = { ...filters, ...{ offset: 0, limit: 100000, withRoles: true } };
      dispatch(makeUnitsWithRoles(updatedQuery));
    } catch (err) {
      dispatch(setNotification({ textKey: 'error', variant: 'error' }));
    }
  };
};

export const makeRemoveUnitRole = (unitId: string, data: RemoveUnitRoleRequestInterface) => {
  return async (dispatch, getState) => {
    try {
      await removeUnitRole(unitId, data);
      const store = getState();
      const filters = store.unit.unitsFilters;

      const updatedQuery = { ...filters, ...{ offset: 0, limit: 10000, withRoles: true } };
      dispatch(makeUnitsWithRoles(updatedQuery));
    } catch (err) {
      dispatch(setNotification({ textKey: 'error', variant: 'error' }));
    }
  };
};

export const makeUnitsWithRoles = (query?: UnitQueryInterface) => {
  const instanceName = 'units';
  return async (dispatch) => {
    try {
      const { items, total } = await getAllUnits(query);
      dispatch(setUnits(items));
      dispatch(totalItems(total, instanceName));
    } catch (err) {
      dispatch(setNotification({ textKey: 'error', variant: 'error' }));
    }
  };
};

export const setUnitsFiltersPartially = (query?: Partial<UnitQueryInterface>) => {
  return (dispatch, getState) => {
    const store = getState();
    const filters = store.unit.unitsFilters;

    const updatedQuery = { ...filters, ...query };

    dispatch({
      type: unitActionTypes.SET_UNITS_FILTERS,
      payload: updatedQuery,
    });
  };
};
